import Vue from 'vue'
import util from './util'
import sdtjMixin from './mixin/sdtj'

util.init()
Vue.mixin(sdtjMixin)
if (util.isInMpSdtj) {
  import('./style/sd-health.less')
}
